// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-section {
    padding-bottom: 7px;
}

.header-front {
    box-shadow: 0 1px 5px 0 rgb(0 0 0 / 10%) !important;
}

#logoAndNav{
    padding-top: 8px;
}

.nav {
    display: block;
    text-align: left;
    border: 0px;
}

.nav li {
    margin: 0px !important;
}

.card-header {
    padding: 30px 0px 30px 20px;
}

.bg-integral {
    background: linear-gradient(70deg, #9b2dd8, #218eef) !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layouts/User/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+DAA+D;AACnE","sourcesContent":[".header-section {\n    padding-bottom: 7px;\n}\n\n.header-front {\n    box-shadow: 0 1px 5px 0 rgb(0 0 0 / 10%) !important;\n}\n\n#logoAndNav{\n    padding-top: 8px;\n}\n\n.nav {\n    display: block;\n    text-align: left;\n    border: 0px;\n}\n\n.nav li {\n    margin: 0px !important;\n}\n\n.card-header {\n    padding: 30px 0px 30px 20px;\n}\n\n.bg-integral {\n    background: linear-gradient(70deg, #9b2dd8, #218eef) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
